import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { estatePackageCreationFilteringSchema } from '../estatePackageCreationSchema';
import { EstatePackageCreationListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import divisionService from '../../Devision/services';

const screenCode = 'ESTATEPACKAGE'

export function EstatePackageCreationFiltering(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Estate Package");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoint, setCollectioPoint] = useState();
    const [estatePackageCreationData, setEstatePackageCreationData] = useState([]);
    const [estatePackageCreation, setEstatePackageCreation] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [allowedOperationEntities, setAllowedOperationEntities] = useState([]);
    const schema = Joi.object(estatePackageCreationFilteringSchema).options({ allowUnknown: true });


    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [estatePackageCreation.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointForDropDown()
        )

        if(estatePackageCreation.operationEntityID != '0'){
            handleSearch();
        }
        
    }, [estatePackageCreation.operationEntityID]);

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWESTATEPACKAGE');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITESTATEPACKAGE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        setAllowedOperationEntities(token.operationEntities || [])
        setEstatePackageCreation({
            ...estatePackageCreation,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getEstatesByGroupID(estatePackageCreation.groupID);
        const allowedIDs = allowedOperationEntities.map(entity => entity.OperationEntityID);
        const filtered = Object.fromEntries(
            Object.entries(opEntities).filter(
                ([id, name]) => allowedIDs.includes(parseInt(id))
            )
        );
        setOperationEntity(filtered);
    }

    async function getCollectionPointForDropDown() {
        const collectionPoint = await services.getCollectionPointByOperationEntityId(estatePackageCreation);
        setCollectioPoint(collectionPoint);

    }

    function handleGroupChange(target){
        validateInputs(target);

        setEstatePackageCreation({
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0'
        });
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setEstatePackageCreation({
            ...estatePackageCreation,
            operationEntityID: target.value,
            collectionPointID: '0'
        });
    }

    function handleCollectionPointChange(target){
        validateInputs(target);

        setEstatePackageCreation({
            ...estatePackageCreation,
            collectionPointID: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, estatePackageCreationFilteringSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);

    }

    async function handleSearch(e) {
        if(e !== undefined){
            const errorMessages = validate(schema, estatePackageCreation);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getEstatePackageFilterData(estatePackageCreation);
        setEstatePackageCreationData(response);
    }

    async function editestatePackageCreation(data) {
        props.history.push({
            pathname: 'estatePackage/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        setEstatePackageCreation({
            ...estatePackageCreation,
            groupID: '0',
            operationEntityID: '0',
            collectionPointID: '0',
        });
        setEstatePackageCreationData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="estatePackage/AddEdit"
                                    buttonText="Add Estate Package"
                                />
                            </div>
                            <hr />

                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={estatePackageCreation.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={estatePackageCreation.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={estatePackageCreation.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <EstatePackageCreationListing estatePackageCreationData={estatePackageCreationData} handleClick={editestatePackageCreation} hasEdit={permissionList.isAddEditEnabled}/>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}